import { render, staticRenderFns } from "./flexibleCodeDel.vue?vue&type=template&id=567e59c9&scoped=true&"
import script from "./flexibleCodeDel.vue?vue&type=script&lang=js&"
export * from "./flexibleCodeDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e59c9",
  null
  
)

export default component.exports